module.exports = __webpack_public_path__ + "media/kommuner-forenklet-class-3P2aE.svg";